import { graphql } from 'src/graphql';

export const ChatHistory = graphql(`
  query ChatHistory($first: Int) {
    chatHistory(first: $first) {
      nodes {
        id
        createdAt
        updatedAt
        title
        teamId
        createdBy
      }
    }
    concepts {
      count
    }
  }
`);
